import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useLearning } from "../../lib/learning";
import CourseCard from "./CourseCard";

export default function CourseGrid({ level }) {
  const [courses, setCourses] = useState(null);
  const { progress } = useLearning();
  useEffect(() => { api.get("/courses").then((r) => setCourses(r.data)); }, []);
  const shown = (courses || []).filter((c) => !level || level === "All" || c.level === level);
  if (courses && !shown.length) return <p className="text-sm text-slate-500" data-testid="courses-empty">No courses at this level yet.</p>;
  return (
    <div className="grid gap-7 md:grid-cols-2 lg:grid-cols-3" data-testid="course-grid">
      {shown.map((c, i) => <CourseCard key={c.slug} course={c} prog={progress[c.slug]} index={i} />)}
    </div>
  );
}
